// German translations - using English as fallback for now
export default {
  // Common
  app: {
    name: 'Coloursense',
    tagline: 'Entdecke Deine Perfekten Farben',
  },
  common: {
    back: 'Zurück',
    cancel: 'Abbrechen',
    save: 'Speichern',
    share: 'Teilen',
    create: 'Erstellen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    loading: 'Wird geladen...',
    error: 'Ein Fehler ist aufgetreten',
    success: 'Erfolg!',
    tryAgain: 'Erneut versuchen',
    reset: 'Zurücksetzen',
  },

  // Premium Features
  premium: {
    title: 'Premium-Funktionen freischalten',
    subtitle:
      'Upgrade auf Coloursense Premium für vollen Zugriff auf alle Funktionen',
    smartWardrobe: 'Intelligenter Kleiderschrank',
    wardrobeDesc:
      'Markiere deine Kleidung und entdecke, was zu deiner Farbpalette passt',
    wearToday: 'Was heute tragen',
    wearTodayDesc:
      'Erhalte KI-gestützte Outfit-Vorschläge basierend auf dem Wetter und deinen Farben',
    unlimited: 'Unbegrenzte Analysen',
    unlimitedDesc:
      'Erstelle unbegrenzt Farbprofile und speichere deinen Analyseverlauf',
    noAds: 'Keine Werbung',
    noAdsDesc: 'Genieße eine werbefreie Erfahrung in der gesamten App',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    save: 'Spare 30%',
    perMonth: 'pro Monat',
    perYear: 'pro Jahr',
    upgradeButton: 'Auf Premium upgraden',
    processing: 'Verarbeitung...',
    restore: 'Käufe wiederherstellen',
  },

  // Subscription Context
  subscription: {
    freePlan: 'Kostenloser Plan',
    premiumPlan: 'Premium-Plan',
    upgradeSuccess: 'Erfolgreich auf Premium aktualisiert!',
    upgradeError: 'Upgrade auf Premium fehlgeschlagen',
    restoreSuccess: 'Käufe erfolgreich wiederhergestellt!',
    restoreError: 'Wiederherstellung der Käufe fehlgeschlagen',
    premiumRequired: 'Premium erforderlich',
    premiumFeature: 'Dies ist eine Premium-Funktion',
    upgradeToAccess: 'Upgrade auf Premium, um auf diese Funktion zuzugreifen',
    goToPremium: 'Zu Premium gehen',
    continueFree: 'Mit kostenlosem Plan fortfahren',
  },
};
